import React, { useEffect, useState } from "react";
import BoyAvtar from "../../../../assets/images/boy_avtar.svg";
import GirlAvtar from "../../../../assets/images/girl_avtar.svg";
import { messageCount as messageCountService } from "../../AxiosRtk/Messages";
import useDeviceStatus from "../../../customHooks/deviceStatusProvider";
import { useSelector } from "react-redux";
import useFirebase from "../../../../useFirebase";
import { formattedDateTimeForChatModule } from "../../../../utils/helper";

const ChildRow = ({
  item,
  dispatch,
  getImage,
  chatSelectKid,
  setChatSelectKid,
}) => {
  const { ID, gender, image, thumbnail, childName, parentID, dateCreated } =
    item;
  const [count, setCount] = useState(null);
  const [isDeviceActive, setIsDeviceActive] = useState(-1);

  const { kidList } = useSelector(({ dashboard }) => dashboard);
  const { getDeviceStatus } = useFirebase();

  useEffect(() => {
    const payload = {
      kidId: ID,
      parentId: parentID,
    };
    messageCountService(payload)
      .then((res) => {
        setCount(res?.data?.result[0]);
      })
      .catch((err) => {
        console.log("msg count catch error ==>>", err?.response?.data?.message);
      });
  }, []);

  useEffect(() => {
    const kidDevicesList = kidList?.find((item) => item?.ID == ID)?.KidsDevices;
    if (kidDevicesList?.length > 0) {
      findDeviceStatus(kidDevicesList);

      const interval = setInterval(
        () => findDeviceStatus(kidDevicesList),
        30000
      );
      return () => {
        clearInterval(interval);
      };
    }
  }, [ID]);

  const findDeviceStatus = (kidDevicesList) => {
    const promiseArr = [];
    kidDevicesList
      ?.filter((item) => item?.KidsDeviceId)
      .forEach((item) => {
        promiseArr.push(() => getDeviceStatus(item?.KidsDeviceId));
      });

    Promise.all([...promiseArr.map((promiseFn) => promiseFn())])
      .then((res) => {
        let isStatusTrue = -1;
        res?.forEach((item) => {
          if (item?.data?.deviceStatus === 1) {
            isStatusTrue = 1;
          } else {
            isStatusTrue = 0;
          }
        });
        setIsDeviceActive(isStatusTrue);
      })
      .catch((err) => {
        console.log("err ==>>", err);
      });
  };
  return (
    <li
      id={ID}
      className={`pt-cursor ${chatSelectKid?.ID === ID ? "child-active" : ""}`}
      onClick={() => setChatSelectKid(item)}
    >
      <div className="user-image ratio ratio-1x1 border-0">
        
        <img
          src={getImage(image, gender)}
          alt=""
          className="img-fluid"
          onError={(event) => {
            event.target.onerror = null;
            event.target.src = getImage("", gender);
          }}
        />
        <span
          className={
            isDeviceActive == 1
              ? "user-online user-status"
              : isDeviceActive == 0
                ? "user-offline user-status"
                : ""
          }
        ></span>
      </div>
      <div className="flex-fill">
        <div className="user-name-time">
          <h5 className="mb-0 text-break">{childName}</h5>
          <span className="text-small text-gray text-nowrap">
            {formattedDateTimeForChatModule(item?.dateCreated)}
          </span>
        </div>
        <div className="user-msg">
          <p className="mb-0 text-small text-gray text-break">
            {item?.type == 2 && <i className="icon-placeholder text-blue-800" />}
            {item?.message ? item?.type == 1 ? item?.message : " Image file" : ""}
          </p>

          {/*count?.parentMsgCount > 0 && (
            <span className="user-unread-msg text-center text-small">
              {count?.parentMsgCount > 99 ? "99+" : count?.parentMsgCount}
            </span>
          )*/}
          {item?.isRead == 0 && item?.count ? (
            <span className="user-unread-msg text-center text-small">
              {item?.count > 99 ? "99+" : item?.count}
            </span>
          ) : (
            ""
          )}
        </div>
      </div>
    </li>
  );
};

export default ChildRow;
